import { Subject } from 'rxjs'

const multiselectCtxMenuCopy = new Subject<void>()
const nodeCtxMenuCopy = new Subject<void>()

export const BpmnNodeRxjsEvents = {
  multiselectCtxMenuCopy,
  nodeCtxMenuCopy,
}
